module.exports = __webpack_public_path__ + "img/video3.d37c090f.jpg";